import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import styled from "styled-components";
import Image from "./image";

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Category = styled(Link)`
  width: 100%;
  background-color: var(--color-white);
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  padding: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0.5rem 0;
  }

  &:hover {
    box-shadow: var(--box-shadow);
    border: 1px solid var(--color-accent2);
  }

  p {
    text-align: center;
    font-weight: 800;
    font-size: 0.9rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 0.8rem;
    }
  }
`;

const ImageContainer = styled.div`
  padding: 1rem;
  width: 70%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProductCategoryBlock = ({ categories }) => {
  return (
    <Wrapper>
      {categories?.map((category, index) => (
        <Category key={index} to={category.uri}>
          <ImageContainer>
            <Image image={category.image} />
          </ImageContainer>
          <p>{category.name}</p>
        </Category>
      ))}
    </Wrapper>
  );
};

ProductCategoryBlock.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      uri: PropTypes.string,
      image: PropTypes.object,
    })
  ),
};

export default ProductCategoryBlock;
